// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3rvzk","inputWrap":"Table_inputWrap__3kHcl","col":"Table_col__6hRuM","bmiTooltip":"Table_bmiTooltip__1_8eW"};